import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Twitter: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58">
            <g id="YT" transform="translate(-9890.309 -6042.478)">
                <g
                    id="Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                    data-name="Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                    transform="translate(9890.309 6042.478)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                >
                    <rect width="59" height="58" rx="29" stroke="none" />
                    <rect x="1" y="1" width="57" height="56" rx="28" fill="none" />
                </g>
                <g
                    id="Icon_ICON_feather_twitter_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_"
                    data-name="Icon [ICON=feather/twitter][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]"
                    transform="translate(9907.856 6059.195)"
                >
                    <rect
                        id="Area_ICON:feather_twitter_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                        data-name="Area [ICON:feather/twitter][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                        width="24"
                        height="24"
                        transform="translate(0.452 0.282)"
                        fill="rgba(253,73,198,0.35)"
                        opacity="0"
                    />
                    <g id="Icon" transform="translate(0 3.652)">
                        <path
                            id="_7392e68a-2f22-414f-8157-3d8e46147d7e"
                            data-name="7392e68a-2f22-414f-8157-3d8e46147d7e"
                            d="M24.959,6.338a3.1,3.1,0,0,0-2.167-2.233c-1.92-.469-9.6-.469-9.6-.469s-7.683,0-9.6.513A3.106,3.106,0,0,0,1.423,6.382a32.4,32.4,0,0,0-.513,5.907,32.449,32.449,0,0,0,.513,5.952,3.1,3.1,0,0,0,2.167,2.143c1.92.513,9.6.513,9.6.513s7.681,0,9.6-.513a3.1,3.1,0,0,0,2.167-2.233,32.346,32.346,0,0,0,.513-5.862A32.445,32.445,0,0,0,24.959,6.338Z"
                            transform="translate(-0.908 -3.636)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                        <path
                            id="ca84794e-f88b-4b53-a7a5-4c5ddddbcd16"
                            d="M8.863,15.011l6.42-3.651-6.42-3.65Z"
                            transform="translate(0.907 -2.706)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Twitter);
